import { appendChameleonScript, initializeErrorTracking, initializeRum } from '@chronosphereio/core';
import { enableMapSet } from 'immer';
import { createRoot } from 'react-dom/client';
import { isPreviewDeploymentActive } from '@/admin';
import { setMuiXProLicenseKey } from '@/utils';
import { APPLICATION_ID } from './App';
import { Router } from './Router';

if (typeof URL.canParse !== 'function') {
  URL.canParse = (url: string | URL, base?: string) => {
    try {
      new URL(url, base);
      return true;
    } catch {
      return false;
    }
  };
}

// Only initialize error tracking if we're not in a preview deployment
if (!isPreviewDeploymentActive()) {
  initializeErrorTracking();
  initializeRum();
}

enableMapSet();
setMuiXProLicenseKey();
appendChameleonScript();

const rootEl = document.getElementById(APPLICATION_ID);
if (rootEl === null) {
  throw new Error('Root relement for react rendering not found');
}

const root = createRoot(rootEl);
root.render(<Router />);
